<template>
  <div class="animated fadeIn">
    <div class="my-5">
      <div class="display-4 font-3xl text-center">
        <span>{{ getTitle }}</span>
      </div>
      <div
        v-if="
          compiledProject &&
            compiledProject.submissions &&
            compiledProject.submissions.length
        "
      >
        <div v-if="validated">
          <div v-if="valid" class="mt-4">
            <project-review-card
              :project="compiledProject"
              :managedLists="managedLists"
            />
            <div class="clearfix my-1">
              <b-button
                class="float-right"
                variant="success"
                size="lg"
                @click="saveProjectAndCheckout"
                >{{ complete_label }}</b-button
              >
            </div>
          </div>
          <div v-else class="mt-4">
            <template v-if="errors && errors.length">
              <b-alert
                v-for="(error, k) in errors"
                show
                variant="warning"
                :key="'validation-error-' + k"
              >
                {{ error }}
              </b-alert>
            </template>
          </div>
        </div>
        <b-row v-if="!valid">
          <b-col cols="4"/>
          <b-col>
            <b-overlay :show="validating" spinner-small spinner-variant="info">
              <b-button
                block
                variant="info"
                class="text-white font-weight-bold my-4"
                size="lg"
                @click="validate"
              >
                {{
                  validated
                    ? "Re-Validate Project Submission"
                    : "Validate Project Submission"
                }}
              </b-button>
            </b-overlay>
          </b-col>
          <b-col />
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectModel from "@/models/lab/ProjectModel";
import config from "../config";
import ProjectReviewCard from "../components/cards/ProjectReviewCard";

export default {
  components: { ProjectReviewCard },
  name: "ProjectWizardStep3",
  props: {
    sampleType: {
      type: Object,
      default: () => null
    },
    compiledProject: {
      type: Object,
      default: () => null
    },
    managedLists: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      total: null,
      validated: false,
      validating: false,
      valid: false,
      errors: [],
      admin: config.admin,
      complete_label: config.complete_label,
      continue_label: config.continue_label
    };
  },
  computed: {
    getTitle() {
      return this.compiledProject &&
        this.compiledProject.submissions &&
        this.compiledProject.submissions.length
        ? this.validated
          ? !this.valid
            ? "Project/Sample(s) are invalid. Correct the issues below and then re-validate to contiue."
            : "Your sample(s) are filled out correctly, click one of the options below to continue."
          : "Click the button below to validate your project."
        : "Once you fill your sample(s), you can review your submission.";
    }
  },
  methods: {
    validate() {
      this.validating = true;
      new ProjectModel().validate(this.compiledProject).then(
        () => {
          this.validated = true;
          this.valid = true;
          this.validating = false;
        },
        err => {
          this.validated = true;
          this.valid = false;
          this.errors = err.response.response.data.simplified;
          this.validating = false;
        }
      );
    },
    saveProjectAndCheckout() {
      this.$emit("saveProjectAndCheckout");
    }
  }
};
</script>
